module.exports = __webpack_public_path__ + "img/pin-in-10.c4c8c887.svg";